import { render, staticRenderFns } from "./AnnualWorkflowCards.vue?vue&type=template&id=40f57a07&scoped=true"
import script from "./AnnualWorkflowCards.vue?vue&type=script&lang=js"
export * from "./AnnualWorkflowCards.vue?vue&type=script&lang=js"
import style0 from "./AnnualWorkflowCards.vue?vue&type=style&index=0&id=40f57a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f57a07",
  null
  
)

export default component.exports